// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2DhEK","options":"AnswerScale_options__2S9-h","selected":"AnswerScale_selected__1CFKo"};